<template>
  <div class="access-history">
    <div class="header">
      <div class="title">Access History</div>
    </div>
    <div class="body">
      <div class="content">
        <div class="info-container">
          You are currently accessing CHeKT from IP Address 61.84.46.228 in Kyunggi-do, Republic of Korea
        </div>
      </div>
    </div>
    <div class="body">
      <div class="content">
        <div class="info-container">
          The following apps has accessed your account since Friday, August 3 2018
        </div>
        <div class="info-container">
          <div class="tr">
            <div class="th">App</div>
            <div class="th">Accessed</div>
            <div class="th">IP Address<br>(Estimated Location)</div>
          </div>
          <div class="tr">
            <div class="td">Monitoring Web</div>
            <div class="td">2018-10-13T00:12:33</div>
            <div class="td">61.84.46.228<br>Kyunggi-do, Republic of Korea</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'access-history'
}
</script>

<style scoped>


.access-history {
  /* common */
  color: #fefefe;
  /* size */
  max-width: 700px;
  width: 100%;
  height: 100%;
}

.access-history .header {
  /* common */
  font-size: 14px;
  /* size */
  padding: 20px 16px 40px;
  /* text */
  font-weight: bold;
  /* alignment */
  text-align: left;
}
.access-history .header .title {
  /* common */
  font-size: 3em;
  
}
.access-history .header .description {
  /* common */
  font-size: 2em;
}


.access-history .body {
  /* size */
  padding: 0 16px;
  /* border */
  border-top: 1px solid hsla(0, 100%, 100%, 0.1);
  /* alignment */
  text-align: left;
}

.access-history .body .content {
  /* common */
  color: #fefefe;
  font-size: 16px;
  /* size */
  min-width: 240px;
  width: 100%;
  min-height: 4em;
  margin: 16px 0;
  /* border */
  /* outline: 1px solid red; */
}

.access-history .body .content .info-container:first-child {
  margin-top: 0;
}
.access-history .body .content .info-container {
  /* common */
  font-size: 14px;
  /* size */
  width: 100%;
  margin: 1em 0;
  /* alignment */
  display: table;
}

.access-history .body .content .tr {
  /* size */
  padding: 0;
  /* alignment */
  display: table-row;
}
.access-history .body .content .td {
  /* common */
  background-color: hsla(0, 100%, 100%, 1);
  color: #000;
  /* size */
  padding: 1em;
  /* alignment */
  display: table-cell;
}
.access-history .body .content .th {
  /* common */
  background-color: hsla(0, 100%, 100%, 0.1);
  /* size */
  padding: 1em;
  /* alignment */
  display: table-cell;
  vertical-align: middle;
}

</style>



// WEBPACK FOOTER //
// src/pages/Account/AccessHistory.vue